import { observer } from 'mobx-react';
import { useStore } from 'models/utils';
import React, { FC, useCallback } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import LoadingScreen from './LoadingScreen';
import { Routes } from '../constants';

// A wrapper for <Route> that redirects to the landing
// screen if you're not yet authenticated.
export const AuthenticatedRoute: FC<RouteProps & { children?: never }> = observer(
  ({ component: Component, ...rest }) => {
    const { currentUser } = useStore();

    const renderer = useCallback(
      (props) => {
        if (!currentUser.isAuthenticated) {
          return <Redirect to={Routes.auth} />;
        }
        if (currentUser.isLoading) {
          return <LoadingScreen />;
        }
        return Component && <Component {...props} />;
      },
      [Component, currentUser.isAuthenticated, currentUser.isLoading]
    );

    return <Route {...rest} render={renderer} />;
  }
);
